import { render, staticRenderFns } from "./ModalContaBancaria.vue?vue&type=template&id=eb60961a"
import script from "./ModalContaBancaria.vue?vue&type=script&lang=js"
export * from "./ModalContaBancaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports